module.exports = __webpack_public_path__ + "fonts/NotoSans-Light.d04dd870.woff";